<template>
  <div class="container">
    <div class="logo">
      <img src="../../assets/img/bioplan_logo.png" @click="goToArchive" role="button" />
    </div>
    <LoadingSpinner v-if="slidesLoading"></LoadingSpinner>
    <template v-else>
      <div class="slider" :style="{ 'background-image': 'url(' + currentSlide.url + ')' }">
        <div class="left" v-if="hasPreviousSlide" @click="currentSlideIndex--" role="button"></div>
        <div class="right" v-if="hasNextSlide" @click="currentSlideIndex++" role="button"></div>
        <div class="right" v-if="!hasNextSlide" @click="goToArchive" role="button"></div>
      </div>
    </template>
    <div class="information">
      <img src="../../assets/img/bioplan_signet.png" class="signet" />
      <div v-if="currentSlide" class="content">
        <span class="title">{{ currentSlide.title }}</span><br />
        <span class="description">{{ currentSlide.description }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import LoadingSpinner from '../parts/LoadingSpinner'
  import rest from '../../services/rest'

  export default {
    name: 'component',
    components: {
      LoadingSpinner
    },
    data () {
      return {
        slides: [],
        currentSlideIndex: 0,
        slidesLoading: true
      }
    },
    computed: {
      currentSlide () {
        if (!this.slides || this.slides.length <= 0 || this.currentSlideIndex >= this.slides.length) { return null }
        return this.slides[this.currentSlideIndex]
      },
      hasNextSlide () {
        if (!this.slides || this.slides.length <= 0 || !this.currentSlide) { return false }
        return this.currentSlideIndex < this.slides.length - 1
      },
      hasPreviousSlide () {
        if (!this.slides || this.slides.length <= 0 || !this.currentSlide) { return false }
        return this.currentSlideIndex > 0
      }
    },
    methods: {
      loadSlides () {
        this.slidesLoading = true
        rest.slides.all((response, hasError) => {
          if (hasError) { return }
          this.slides = response.data
          if (this.slides && this.slides.length > 0) {
            this.currentSlideIndex = 0
            this.slidesLoading = false
          }
        })
      },
      goToArchive () {
        this.$router.push({ name: 'Archive' })
      }
    },
    mounted () {
      this.loadSlides()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .logo {
    position: absolute;
    left: 25px;
    top: 25px;
    z-index: 9999;
    width: 242px;
  }
  .logo img {
    cursor: pointer;
    width: 100%;
  }
  @media (max-width: 292px) {
    .logo {
      width: calc(100% - 50px);
    }
  }
  .container {
    height: 100%;
    margin-top: 0;
  }
  .slider {
    /* Full height - bottom part */
    height: calc(100% - 107px);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .slider .left {
    position: absolute;
    cursor: url("../../assets/img/pfeil_links_white.cur"), url("../../assets/img/pfeil_links_white.png"), pointer;
    left: 0;
    top: 0;
    right: 50%;
    bottom: 107px;
  }
  .slider .right {
    position: absolute;
    cursor: url("../../assets/img/pfeil_rechts_white.cur"), url("../../assets/img/pfeil_rechts_white.png"), pointer;
    left: 50%;
    top: 0;
    right: 0;
    bottom: 107px;
  }
  .information .content {
    position: absolute;
    top: 25px;
    bottom: 25px;
    left: 400px;
    width: 350px;
    color: black;
  }
  .information .content .description {
    font-family: 'bioregular';
  }
  @media (max-width: 655px), (max-height: 400px) {
    .slider {
      height: calc(100% - 50px);
    }
    .information .content {
      top: 10px;
      bottom: 0;
      left: 60px;
      width: calc(100% - 65px);
    }
    .information .content .description {
      white-space: nowrap;
    }
    .slider .right, .slider .left {
      bottom: 50px;
    }
  }
</style>



// WEBPACK FOOTER //
// HomeSlider.vue?4ae80d80